import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { logEvent } from '../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import styles from './StartSlideV5.css';

function StartSlideV5({
    id,
    startQuestion,
    onContinue
}) {
    const handleChange = answer => () => {
        logEvent(EVENT_TYPES.QUIZ_START_CLICKED, { label: answer.text });
        onContinue({ ...answer, questionId: startQuestion.id, question: startQuestion.question });
    };

    return (
        <div className={styles.form} key={id}>
            <div className={styles.headingBlock}>
                <h1 className={styles.heading}>Find out how full your life has really been</h1>
                <p className={styles.subheading}>You get a Life Richness Score at the end — and personalize the subscription</p>
            </div>
            <div className={styles.questionBlock}>
                <p className={styles.question}>{startQuestion.question}</p>
                <ul className={styles.answers}>
                    {startQuestion.answers.map(answer => (
                        <li key={answer.id} className={styles.answer}>
                            <button
                                type='button'
                                onClick={handleChange(answer)}
                                className={styles.answerCard}
                            >
                                <span className={styles.photo}>
                                    <img src={answer.imageSrc} alt='' className={styles.photoImage} />
                                </span>
                                <span className={styles.label}>
                                    <span className={styles.labelText}>{answer.text}</span>
                                    <Icon name='chevronRight' className={styles.chevronIcon} />
                                </span>
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

StartSlideV5.propTypes = {
    id: PropTypes.number.isRequired,
    startQuestion: PropTypes.shape({
        id: PropTypes.number.isRequired,
        question: PropTypes.string.isRequired,
        answers: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number.isRequired,
            text: PropTypes.string.isRequired,
            imageSrc: PropTypes.string.isRequired
        })).isRequired
    }).isRequired,
    onContinue: PropTypes.func.isRequired
};

export {
    StartSlideV5
};
